<app-accordion
  expandHeight="100px"
  [expanded]="item.expanded"
  *ngFor="let item of items"
>
  <div class="accordion-title" (click)="expandItem(item)">
    <ion-icon
      [name]="item.expanded ? 'caret-up-outline' : 'caret-down-outline'"
    ></ion-icon>
    {{ item.title }}
  </div>
  <div class="accordion-content" [innerHtml]="item.answer"></div>
</app-accordion>
